import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-prasiddhi-patrak-address',
  templateUrl: './prasiddhi-patrak-address.component.html',
  styleUrls: ['./prasiddhi-patrak-address.component.scss']
})
export class PrasiddhiPatrakAddressComponent {

  Address: any;
  pincode: any;
  name: any;
  issuenamenew: any;
  cust_name: any;
  issuedatepp: any;
  val: any;
  advt_name: any;
  rep_name: any;
  off_rep_name: any;
  issue_category: any;
  issue_dates: any;
  issue_date: string;
  issue_name: any;
  today: Date;
  district: any;
  taluka: any;
  modetype: any;
  start_date: any;
  end_date: any;
  prantname: any;
  country: any;
  state: any;
  duration: any;
  currentDate= new Date();

  constructor(
    private dialogRef: MatDialogRef<PrasiddhiPatrakAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    debugger;
    this.issuenamenew = this.data['issuenamenew'];
    this.cust_name = this.data['cust_name'];
    this.issuedatepp = this.data['issuedatepp'];
    this.start_date = this.data['start_date'];
    this.end_date = this.data['end_date'];
    this.val = this.data['val'];
    this.district = this.data['district'];

    this.advt_name = this.data['advt_name'] || '';
    this.rep_name = this.data['rep_name'] || '';
    this.off_rep_name = this.data['off_rep_name'] || '';
    this.issue_category = this.data['issue_category'] || '';
    this.issue_dates = this.data['issue_date'] || '';

    this.issue_date = this.data['issue_date'] + '';
    if (this.issue_date.includes(',')) {
      [this.issue_date, this.issue_name] = this.issue_date.split(',');
    }
    this.today = new Date();
    
    this.getAllAdd(this.val);
  }

  getAllAdd(val: any) {
   const req={
      'value':val,
      'issue_name' : this.issue_category,
      'issue_date' : this.issue_dates,
      'start_date': this.start_date,
      'end_date': this.end_date,
      'advt_name' : this.advt_name,
      'rep_name' : this.rep_name,
      'off_rep_name' : this.off_rep_name
      
    }

    console.log(req, "new all address");

    this.service.getAllAdd(req).subscribe(
      (data: any) => {
        console.log("pending add=", data);
        this.Address = data;
      },
      (error) => {
        console.error("Error fetching addresses:", error);
      }
    );

    console.log("req 2 for add", req);
  }

  print() {
    const originalTitle = document.title; // Store original title
    document.title = '';     // Set custom print title
  
    // Create a style tag for print-specific styles
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 20mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;
  
    document.head.appendChild(style); // Add style to the document
  
    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();
      
      document.title = ''; // Restore original title after printing
      
      // document.head.removeChild(style); // Remove the style after printing
    }, 500); // Delay ensures styles apply before printing
  }
  
  
 
    //  exportexcel(fileName): void {
    //    console.log('Export function called with fileName:', fileName);
       
    //    let element = document.getElementById('print-section');
    //    console.log('Element found:', element);
       
    //    if (!element) {
    //      console.error('Element with ID "print-section" not found in DOM');
    //      return;
    //    }
       
    //    try {
    //      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    //      console.log('Worksheet created:', ws);
         
    //      const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
         
    //      XLSX.writeFile(wb, fileName + '.xlsx');
    //      console.log('File should be downloaded');
    //    } catch (error) {
    //      console.error('Error during export:', error);
    //    }
    //  }

exportexcel(fileName: string): void {
  const data: any[] = [];

  this.Address.forEach(group => {
    group.forEach(d => {
      data.push({
        Name: d.name,
        Address: `${d.address}, ${d.taluka}, ${d.district} - ${d.pincode}, ${d.state}`,
        Mobile: d.mobile
      });
    });
  });

  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

  }
